module.exports = require("npm:async.util.onlyonce@0.5.2/index.js");